// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { shareListModalStyles } from "@synd/Overrides/Components/ShareListModal";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

shareListModalStyles.shareListTooltip =
    shareListModalStyles.recipientEmailTooltip =
    shareListModalStyles.shareByEmailTooltip =
    shareListModalStyles.shareByBillingTooltip =
        {
            iconProps: {
                css: css`
                    &,
                    & svg {
                        height: 16px;
                        width: 12px;
                    }
                `,
            },
        };

shareListModalStyles.buttonsContainer = {
    gap: 10,
    css: css`
        & ${GridOffset} {
            justify-content: space-between;
        }
    `,
};

shareListModalStyles.shareByOptionRadioGroup = {
    css: css`
        flex-direction: row;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

shareListModalStyles.shareByEmailRadio = {
    css: css`
        & + & {
            margin-top: 0 !important;
            margin-left: 20px;
            ${xScreen("lte", "sm")} {
                margin-left: 0;
            }
        }
        input {
            margin-left: 0;
        }
    `,
};

shareListModalStyles.shareListOptionRadioGroup = shareListModalStyles.shareByOptionRadioGroup;

shareListModalStyles.sendCopyRadio = shareListModalStyles.shareByEmailRadio;

shareListModalStyles.container = { gap: 15 };

shareListModalStyles.buttonsGridItem = mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
    css: css`
        padding-top: 10px;
    `,
});

shareListModalStyles.yourNameGridItem = {
    width: [12, 12, 6, 6, 6],
};

shareListModalStyles.recipientEmailAddressGridItem = {
    width: [12, 12, 6, 6, 6],
};

shareListModalStyles.sendButton = modalButtonsActionStyles.submitButton;
shareListModalStyles.cancelButton = modalButtonsActionStyles.cancelButton;
